import type { ReactNode } from 'react';
import { PostAuthNavbar } from '@/components/navigation/PostAuthNavbar';
import { Footer } from '@/components/marketing/Footer';

interface PageLayoutProps {
    children: ReactNode;
    nav?: boolean;
    footer?: boolean;
    className?: string;
}

export function PageLayout({
    children,
    nav = true,
    footer = false,
    className = "min-h-screen bg-background"
}: PageLayoutProps) {
    return (
        <div className={`${className} ${footer ? 'flex flex-col' : ''}`}>
            {nav && <PostAuthNavbar />}
            <main className={footer ? 'flex-1' : ''}>
                {children}
            </main>
            {footer && <Footer />}
        </div>
    );
}
